/**
 * Which store a filter-panel section reads from.
 *
 * Portfolios, tag watchlists and headline queries each have their own id
 * sequence, so id 7 exists three times over and means three different lists.
 * A panel row carries only the bare record id, so its section is the only
 * thing that says which store to read — resolving without it is a guess.
 *
 * Kept in its own module, free of React and the CRUD hooks, so the mapping is
 * unit-testable: importing the modal pulls in the query layer and, through it,
 * `window`.
 */
export type WatchlistStore = "portfolio" | "tag" | "combined";

export function storeOf(sectionId?: string): WatchlistStore | null {
  if (!sectionId) return null;
  if (sectionId.startsWith("ticker-watchlists")) return "portfolio";
  if (sectionId.startsWith("keyword-watchlists")) return "portfolio";
  if (sectionId.startsWith("tag-watchlists")) return "tag";
  if (sectionId.startsWith("advanced-filters")) return "combined";
  if (sectionId.startsWith("category")) return "combined";
  return null;
}
